/* eslint react/no-multi-comp: 0 */
import React, { useState } from 'react';

import { SearchSelect } from '@ui/components';

const rightsholderOptions = [
    { name: 'Premier League', value: 1 },
    { name: 'La Liga', value: 2 },
    { name: 'Serie A', value: 3 },
    { name: 'Bundesliga', value: 4 },
    { name: 'Ligue 1', value: 5 },
];

export const DefaultSearchSelectExample = () => {
    const [value, setValue] = useState<number | null>(null);

    return (
        <SearchSelect
            options={rightsholderOptions}
            placeholder="Select a rightsholder"
            value={value}
            onChange={next => setValue(next)}
            style={{ width: 240 }}
        />
    );
};

export const SearchFilterSearchSelectExample = () => {
    const [value, setValue] = useState<number | null>(2);

    return (
        <SearchSelect
            options={rightsholderOptions}
            placeholder="Type to filter leagues"
            value={value}
            onChange={next => setValue(next)}
            style={{ width: 240 }}
        />
    );
};

export const MultipleSearchSelectExample = () => {
    const [value, setValue] = useState<number[]>([1]);

    return (
        <SearchSelect
            mode="multiple"
            options={rightsholderOptions}
            placeholder="Select leagues"
            value={value}
            onChange={next => setValue(next)}
            style={{ width: 320 }}
        />
    );
};

export const NoResultsSearchSelectExample = () => (
    <SearchSelect
        options={[]}
        placeholder="No leagues configured"
        style={{ width: 240 }}
    />
);

export const DisabledSearchSelectExample = () => (
    <SearchSelect
        disabled
        options={rightsholderOptions}
        placeholder="Disabled rightsholder filter"
        value={1}
        style={{ width: 240 }}
    />
);

export const LoadingSearchSelectExample = () => (
    <SearchSelect
        loading
        options={[]}
        placeholder="Loading leagues"
        style={{ width: 240 }}
    />
);
